<!--
 * @Author: wuhao
 * @Date: 2020-03-26 13:31:12
 * @LastEditors: wuhao
 * @LastEditTime: 2020-10-19 16:07:28
 * @Description: 封装 el-link
 -->

<template>
  <el-link
    :type="type"
    :underline="underline"
    :disabled="disabled"
    :icon="icon"
    :href="href"
    :to="to"
    :params="params"
    :class="`apex_link_${getSize()}`"
    @click="jump"
  >
    <span v-if="value">{{ value }}</span>
    <slot v-else />
  </el-link>
</template>

<script>
export default {
  name: 'ApexLink',
  props: {
    // 文本内容
    value: {
      type: String,
      default: ''
    },
    // 大小
    size: {
      type: String,
      default: ''
    },
    // 类型
    type: {
      type: String,
      default: 'default'
    },
    // 是否下划线
    underline: {
      type: Boolean,
      default: true
    },
    // 是否禁用状态
    disabled: {
      type: Boolean,
      default: false
    },
    // 图标类名
    icon: {
      type: String,
      default: ''
    },
    // 原生 href 属性
    href: {
      type: String,
      default: null
    },
    // vue-router路由跳转路径
    to: {
      type: String,
      default: ''
    },
    // 路由参数
    params: {
      type: [Function, Object],
      default: () => {}
    },
    // 本行的所有数据，此字段不需要额外配置
    scope: {
      type: [String, Object, Array],
      default: null
    }
  },
  methods: {
    jump() {
      this.$emit('click')
      if (!this.to) return
      if (typeof this.params === 'function') {
        this.$router.push({ path: this.to, query: this.params(this.scope && this.scope.row) })
      } else {
        this.$router.push({ path: this.to, query: this.params })
      }
    },
    getSize() {
      return this.size || (this.$ELEMENT || {}).size
    }
  }
}

</script>

<style lang='scss' scoped>
.apex_link_medium {
  font-size: 14px;
}
.apex_link_small {
  font-size: 13px;
}
.apex_link_mini {
  font-size: 12px;
}
</style>
